export default "__VITE_ASSET__vbU$1LQw__"